import React, { useState, useEffect } from "react";
import _ from "lodash";
import axios from "axios";
import { connect } from "react-redux";
import { setLocalTowns } from "../actions/searchActions";
import {
  getPersistedState,
  setPersistedState,
  clearPersistedSearchFilters,
} from "../actions/persistedStateActions";
import queryString from "query-string";
import PageWrapper from "./PageWrapper";
import SearchBar from "../components/FormComponents/SearchBar";
import SearchPageListings from "../components/SearchPageListings";
import SearchFilters from "../components/FormComponents/SearchFilters";
import BreadcrumbsSearchPage from "../components/Breadcrumbs/BreadcrumbsSearchPage";
import {STATS_URL,  withSearchPageListings} from "../DataProviders/SearchPageListingsProvider";
import LocalTownsList from "../components/Search/LocalTownsList";
import { hasSearchResults } from "../actions/searchActions";
import * as analytics from "../analytics";
import { getAnalyticsSafeURL } from "../utils/analyticsUtilities";
import { PermalinkRedirection } from "../components/HigherOrderComponents/PermalinkRedirection";
import PageHead from "../components/PageHead";

import {
  API_KEYS,
  FINANCIAL_ADVISER_ID,
  LEGAL_ADVISER_ID,
  ACCOUNTANT_ID,
  FA_PROMOTION_IDS,
  PROMOTIONAL_OFFER,
  URL_COMPONENTS,
  PERSISTED_STATE_SEARCH_PAGE,
  PERSISTED_STATE_SEARCH_FILTERS,
} from "../__constants__";
import { getSearchPageMetaData } from "../data/metaTagsHelper";
import { formatSearchLocationParam } from "../data/searchHelper";
import { withRouter } from "next/router";
import FirmSearchPageListings from "../components/Search/FirmSearchPageListings";
import {mapEmptyArr} from "../utils/utilities";
import IndividualTileSkeleton from "../components/FormComponents/Skeletons/IndividualTileSkeleton";

const SearchPageListingsWithProvider = connect(null, { hasSearchResults })(
  withSearchPageListings(SearchPageListings)
);

export function createDefaultParams(state) {
  const {
    vertical_id,
    attribute_ids,
    servicesList,
    showAdviceArea,
    include_travel_professionals,
    is_contactable,
    location,
    promotion,
    search_range,
    latitude,
    longitude,
    wealth_level_ids,
    advanced_qualifications,
    fixed_fees,
    type,
    gender,
  } = state;

  let defaultObject = {
    include_travel_professionals,
    is_contactable,
    location,
    latitude,
    longitude,
    search_range,
    vertical_id,
    wealth_level_ids,
    advanced_qualifications,
    fixed_fees,
    gender,
    ...(type !== "" && { type }),
  };

  if (vertical_id === FINANCIAL_ADVISER_ID) {
    if (attribute_ids) {
      defaultObject.attribute_ids = servicesList
        ? servicesList.toString()
        : attribute_ids;
    } else if (servicesList) {
      defaultObject.attribute_ids = servicesList.toString();
    }

    if (promotion) {
      defaultObject.promotion_ids = FA_PROMOTION_IDS.join(",");
    }
  } else {
    if (showAdviceArea && _.isEmpty(servicesList)) {
      return {};
    }
    if (servicesList) {
      defaultObject.attribute_ids = servicesList.toString();
    }
  }

  if (vertical_id === LEGAL_ADVISER_ID) {
    if (promotion) {
      defaultObject.promotion_ids = PROMOTIONAL_OFFER.LEGAL_ADVISER_FREE_1_HOUR.ID.toString();
    }
  }

  return defaultObject;
}

export function createInitialState(url, view) {
  const nameSearch = queryString.parseUrl(url);
  const parsed = _.split(nameSearch.url, "/");
  const commune = _.intersection(parsed, [
    URL_COMPONENTS.FA_MA_CANONICAL,
    URL_COMPONENTS.SOLICITOR,
    URL_COMPONENTS.ACCOUNTANT,
  ]);
  const index = _.findIndex(parsed, function(item) {
    return item === commune[0];
  });

  const coordinates = _.split(parsed[index + 2], ",");
  const location = decodeURIComponent(parsed[index + 1]);

  let initialState = {
    vertical_id: FINANCIAL_ADVISER_ID,
    location: "",
    city: "",
    attribute_ids: "",
    is_contactable: 1,
    include_travel_professionals: 1,
    search_range: 40,
    gender: null,
    promotion: false,
    servicesList: "",
    wealth_level_ids: null,
    searchType: "location",
    GTMActivated: false,
    showAdviceArea: false,
    urlPath: parsed[index],
    breadcrumbs: {},
    redirect301Url: "",
    searchFilterUrlParams: nameSearch.query,
    advanced_qualifications:
      nameSearch.query && nameSearch.query.advanced_qualifications
        ? nameSearch.query.advanced_qualifications
        : 0,
    fixed_fees:
      nameSearch.query && nameSearch.query.fixed_fees
        ? nameSearch.query.fixed_fees
        : 0,
    showMe: 'advisers'
  };

  if (view && view === 'firms') {
    initialState = {
      ...initialState,
      showMe: view,
    };
  }

  switch (parsed[index]) {
    case URL_COMPONENTS.FA_MA_CANONICAL: {
      initialState = {
        ...initialState,
        vertical_id: FINANCIAL_ADVISER_ID,
        location,
        latitude: coordinates[0] ? coordinates[0] : "",
        longitude: coordinates[1] ? coordinates[1] : "",
      };
      break;
    }
    case URL_COMPONENTS.ACCOUNTANT: {
      initialState = {
        ...initialState,
        vertical_id: ACCOUNTANT_ID,
        location,
        latitude: coordinates[0] ? coordinates[0] : "",
        longitude: coordinates[1] ? coordinates[1] : "",
      };
      break;
    }
    case URL_COMPONENTS.SOLICITOR: {
      initialState = {
        ...initialState,
        vertical_id: LEGAL_ADVISER_ID,
        is_contactable: 0,
        location,
        latitude: coordinates[0] ? coordinates[0] : "",
        longitude: coordinates[1] ? coordinates[1] : "",
      };
      break;
    }
    default:
  }

  initialState.defaultParams = createDefaultParams(initialState);

  const persistedState = getPersistedState(PERSISTED_STATE_SEARCH_PAGE);
  const persistedFiltersState = getPersistedState(
    PERSISTED_STATE_SEARCH_FILTERS
  );

  //if type_filter is set from url
  // check if filter value exists in persisted state and set the filter to that value, if not initialize if with 'ifa'
  const typeFilterSetInUrl =
    nameSearch.query && nameSearch.query.type_filter ? true : false;
  let typeFilterValueFromUrl = "";
  if (typeFilterSetInUrl) {
    const typeFilterStateFromUrl = nameSearch.query.type_filter;
    if (typeFilterStateFromUrl === "1") {
      typeFilterValueFromUrl = persistedFiltersState
        ? persistedFiltersState.type_filter_value
        : "ifa";
      initialState.defaultParams.type = typeFilterValueFromUrl;
    } else {
      initialState.defaultParams.type = "";
    }
  }

  if (persistedState) {
    //if type_filter is set from url set persisted default params accordingly
    if (
      typeFilterSetInUrl &&
      typeFilterValueFromUrl !== "" &&
      persistedState.defaultParams.type !== typeFilterValueFromUrl
    ) {
      persistedState.defaultParams.type = typeFilterValueFromUrl;
    } else if (typeFilterSetInUrl && typeFilterValueFromUrl === "") {
      delete persistedState.defaultParams.type;
    }

    if (nameSearch.query) {
      Object.keys(nameSearch.query).map((filter) => {
        if (filter in initialState.defaultParams) {
          persistedState.defaultParams[filter] = nameSearch.query[filter];
        }
        return true;
      });
    }

    if (initialState.urlPath !== persistedState.urlPath) {
      clearPersistedSearchFilters();

      return initialState;
    }

    return {
      ...initialState,
      GTMActivated: false,
      wealth_level_ids: persistedState.wealth_level_ids,
      attribute_ids: persistedState.attribute_ids,
      latitude: persistedState.latitude,
      longitude: persistedState.longitude,
      search_range: persistedState.search_range,
      gender: persistedState.gender,
      vertical_id: persistedState.vertical_id,
      servicesList: persistedState.servicesList,
      defaultParams: {
        ...persistedState.defaultParams,
        location: initialState.defaultParams.location, // always get the latest location when mounting
      },
    };
  }

  return initialState;
}

const SearchPage = (props) => {
  const [state, setState] = useState(createInitialState(props.router.asPath, props.showMe));
  const [updateSearchParams, setUpdateSearchParams] = useState(false);
  const [runFilterSubmitCallback, setRunFilterSubmitCallback] = useState(false);
  const [
    runHandlePersistStateCallback,
    setRunHandlePersistStateCallback,
  ] = useState(false);
  const [loadingFirmResults, setLoadingFirmResults] = useState(false);

  useEffect(() => {
    activateGTM();
    fetchLocalTownsAndBreadcrumbs();
  }, []);

  useEffect(() => {
    if (updateSearchParams) {
      handleUpdateSearchParams();
      setUpdateSearchParams(false);
    }
  }, [updateSearchParams]);

  useEffect(() => {
    if (runFilterSubmitCallback) {
      if (state.searchType !== "name") {
        const hasEmptyInput =
          state.showAdviceArea && _.isEmpty(state.servicesList);

        setState({
          ...state,
          searchType: hasEmptyInput ? "location-advice-areas" : "location",
        });
        setUpdateSearchParams(true);
      }
      setRunFilterSubmitCallback(false);
    }
  }, [runFilterSubmitCallback]);

  useEffect(() => {
    if (runHandlePersistStateCallback) {
      handlePersistState();
      setRunHandlePersistStateCallback(false);
    }
  }, [runHandlePersistStateCallback]);

  useEffect(() => {
    if (
      state.nextSearchUrl &&
      decodeURI(props.router.asPath) !== state.nextSearchUrl
    ) {
      props.router.push(nextSearchUrl);
    }
  }, [state.nextSearchUrl]);

  const fetchLocalTownsAndBreadcrumbs = async () => {
    const { vertical_id, location, urlPath, showMe } = state;
    if (location) {
      const res = await axios.get(
        `${API_KEYS.API_URL}/v2/public/location/${vertical_id}/${location}`
      );
      const redirect = _.get(res, "data.data.redirect", "");

      if (redirect) {
        const redirectUrl = showMe === 'firms' ? `${urlPath}/${redirect}?view=${showMe}` : `${urlPath}/${redirect}`;
        setState({ ...state, redirect301Url: redirectUrl });
      } else {
        props.setLocalTowns(_.get(res, "data.data.local_towns", []));

        setState({
          ...state,
          breadcrumbs: _.get(res, "data.data.breadcrumbs", {}),
        });
      }
    }
  };

  const activateGTM = () => {
    if (!state.GTMActivated) {
      analytics.track("Visit", {
        category: "Search",
        label: "results_tiles",
      });

      setState({ ...state, GTMActivated: true });
    }
  };

  const handleSubmitLocationSearch = (input) => {
    const urlPath = state.urlPath;
    let url = "/" + urlPath + "/" + getAnalyticsSafeURL(input);
    if (state.showMe && state.showMe === "firms") {
      url = url + "?view=" + state.showMe;
    }

    if (props.router.asPath !== url) {
      setState({
        ...state,
        location: input,
        searchType: "location",
        nextSearchUrl: url,
      });
      setUpdateSearchParams(true);
      setLoadingFirmResults(true);
    }
  };

  const handleShowMeToggle = (showMe) => {
    const url = `/${state.urlPath}/${state.location}?view=${showMe}`;
    if (showMe === "firms") {
      setLoadingFirmResults(true);
    }
    setState({
      ...state,
      searchType: "location",
      nextSearchUrl: url,
    });
  };

  const handleSubmitNameSearch = (firstSearchByNameOption) => {
    if (firstSearchByNameOption && props.router.asPath !== firstSearchByNameOption) {
      setState({
        ...state,
        nextSearchUrl: firstSearchByNameOption,
      });
    }
  };

  const handleFiltersSubmit = (input) => {
    setState({
      ...state,
      search_range: input.search_range,
      gender: input.gender,
      is_contactable: input.is_contactable ? 1 : 0,
      include_travel_professionals: input.include_travel_professionals ? 1 : 0,
      promotion: input.promotion,
      type: input.type_filter ? input.type_filter_value : "",
      advanced_qualifications: input.advanced_qualifications ? 1 : 0,
      fixed_fees: input.fixed_fees ? 1 : 0,
      showAdviceArea:
        state.vertical_id !== FINANCIAL_ADVISER_ID &&
        input.parentList.length > 0,
      wealth_level_ids:
        state.vertical_id === FINANCIAL_ADVISER_ID
          ? input.wealth_level_ids
          : null,
      servicesList:
        state.vertical_id === FINANCIAL_ADVISER_ID
          ? input.parentList
          : input.servicesList,
    });
    setRunFilterSubmitCallback(true);
  };

  const handleUpdateSearchParams = () => {
    setState({ ...state, defaultParams: createDefaultParams(state) });
    setRunHandlePersistStateCallback(true);
  };

  const handlePersistState = () => {
    const stateToPersist = { ...state };

    delete stateToPersist.redirect301Url;

    setPersistedState(PERSISTED_STATE_SEARCH_PAGE, stateToPersist);
  };

  const {
    searchType,
    location,
    vertical_id,
    attribute_ids,
    nextSearchUrl,
    urlPath,
    breadcrumbs,
    redirect301Url,
    showMe,
  } = state;

  return (
    <div>
      <PageWrapper hideButtons>
        <PermalinkRedirection redirect={redirect301Url} />
        {location && (
          <PageHead {...getSearchPageMetaData(state, props.router)} />
        )}
        {searchType !== "name" && (
          <BreadcrumbsSearchPage
            location={location}
            vertical_id={vertical_id}
            city={breadcrumbs?.city}
            town={breadcrumbs?.town}
            showMe={showMe}
          />
        )}
        <SearchBar
          handleSubmitLocationSearch={handleSubmitLocationSearch}
          handleSubmitNameSearch={handleSubmitNameSearch}
          searchType={searchType}
          location={formatSearchLocationParam(location)}
          showMe={showMe}
          handleShowMeToggle={handleShowMeToggle}
          isIfa={urlPath === "IFA-financial-advisor-mortgage"}
          verticalId={vertical_id}
        />
        {
          loadingFirmResults ?
            <div>
              { mapEmptyArr(5, (i) => <IndividualTileSkeleton key={i} />) }
            </div>
            :
            (showMe === "advisers") ?
              <>
                {searchType !== "name" && (
                    <SearchFilters
                        searchFilterUrlParams={state.searchFilterUrlParams}
                        location={location}
                        type={vertical_id}
                        attribute_id={attribute_ids}
                        handleSubmit={handleFiltersSubmit}
                        urlPath={urlPath}
                    />
                )}
                <hr className='border-none h-[1px] m-0 bg-[#000000] opacity-[0.1]' />
                <SearchPageListingsWithProvider
                    url={STATS_URL}
                    searchType={searchType}
                    initialProfessionals={props.initialProfessionals}
                    defaultParams={state.defaultParams}
                    handleSubmit={handleSubmitLocationSearch}
                    urlPath={urlPath}
                    servicesList={state.servicesList}
                />
                {vertical_id === FINANCIAL_ADVISER_ID && (
                    <div className='pt-8 pb-12 px-4 max-md:py-8 max-md:px-2'>
                      <LocalTownsList
                          enableLinks
                          label="Search more locally:"
                          vertical_id={vertical_id}
                      />
                    </div>
                )}
              </>
              :
              <>
                <hr className='border-none h-[1px] m-0 bg-[#000000] opacity-[0.1]' />
                <FirmSearchPageListings
                    searchType={searchType}
                    location={location}
                    initialFirms={props.initialFirms}
                    loadingFirmResults={loadingFirmResults}
                />
              </>
        }
        <div className='mt-12' />
      </PageWrapper>
    </div>
  );
};

const actions = {
  setLocalTowns,
};

export default withRouter(connect(null, actions)(SearchPage));
